import React from "react";
import classNames from "classnames";
import { fromJS } from "immutable";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { shortDate } from "LIB/formatters/date";
import { getFirstNameLastInitial } from "LIB/formatters/text";
import { dollars } from "LIB/formatters/currency";
import {
  CONDITIONS,
  CREDIT_EXCHANGE,
  CUSTOMER_DISPLAYED_SUBTOTAL
} from "MODULES/SalesOrders/constants";
import {
  DataTable,
  SearchPropTypes,
  IconText,
  CompanyName
} from "MODULES/shared/components";
import SalesOrderLineItemStatusCell from "MODULES/shared/components/SalesOrderLineItemStatusCell";
import { CREATED_AT, ID, QUANTITY, SHIPPED } from "APP_ROOT/constants";
import { EXCHANGE_FEE, PRICE_PER_UNIT } from "MODULES/OutgoingQuotes/constants";
import { INVENTORY, SERIAL_NUMBER } from "MODULES/inventories/constants";
import { CANCELLED } from "MODULES/RepairOrders/constants";
import LocationFlag from "../../../shared/components/LocationFlag/LocationFlag";
import { ExchangeIcon } from "../../../SalesOrders/helpers";

function renderRow(result, i, pushHistory) {
  const handleMailto = e => {
    e.stopPropagation();
  };
  const lineItem = fromJS(result);
  const exchangeSale = lineItem.get("exchange_sale");
  const afterHoursIcon =
    lineItem.get("after_hours") && !lineItem.get("internal_outright") ? (
      <IconText note={"After Hours"} margin={"5px"} icon={"fa-clock-o"} />
    ) : null;
  const internalOutrightIcon = lineItem.get("internal_outright") ? (
    <IconText text={"io"} note={"Internal Outright"} />
  ) : null;

  const classes = classNames("clickable", {
    "text-muted": lineItem.get(CANCELLED) || lineItem.get(CREDIT_EXCHANGE)
  });

  return (
    <tr
      key={lineItem.get(ID)}
      className={classes}
      onClick={() =>
        pushHistory(`/sales-orders/${lineItem.get("sales_order_uuid")}`)}
    >
      <td>{i + 1}</td>
      <SalesOrderLineItemStatusCell
        shipped={lineItem.get(SHIPPED)}
        cancelled={lineItem.get(CANCELLED)}
      >
        <td>
          {afterHoursIcon}
          {internalOutrightIcon}
        </td>
      </SalesOrderLineItemStatusCell>
      <td>{lineItem.get("sales_order_code")}</td>
      <td>{shortDate(lineItem.get(CREATED_AT))}</td>
      <td>
        <CompanyName flattenedCompany={lineItem.toJS()} />
      </td>
      <td>{lineItem.get("contact_name")}</td>
      <td>
        <a
          href={`mailto:${lineItem.get("contact_email")}`}
          onClick={handleMailto}
        >
          {lineItem.get("contact_email")}
        </a>
      </td>
      <td>
        {lineItem.get("buyer") &&
          getFirstNameLastInitial(lineItem.getIn(["buyer", "full_name"]))}
      </td>
      <td>
        {lineItem.get("co_buyer") &&
          getFirstNameLastInitial(lineItem.getIn(["co_buyer", "full_name"]))}
      </td>
      <td>
        {getFirstNameLastInitial(lineItem.getIn(["seller", "full_name"]))}
      </td>
      <td>{lineItem.get(SERIAL_NUMBER)}</td>
      <td>{CONDITIONS[lineItem.get("condition")].abbrev}</td>
      <td className="text-center">
        <LocationFlag
          location={lineItem.get("store_location_id")}
          transferStatus={lineItem.getIn([INVENTORY, "transfer_status"])}
        />
      </td>
      <td className="text-center">
        <ExchangeIcon lineItem={lineItem.toJS()} />
      </td>
      <td className="text-left">{lineItem.get(QUANTITY)}</td>
      <td className="text-right">
        {exchangeSale
          ? dollars(lineItem.get(EXCHANGE_FEE))
          : dollars(lineItem.get(PRICE_PER_UNIT))}
      </td>
      <td className="text-right">
        {dollars(lineItem.get(CUSTOMER_DISPLAYED_SUBTOTAL))}
      </td>
    </tr>
  );
}

export function Table(props) {
  const { pushHistory, isLoading, results } = props;

  return (
    <DataTable loading={isLoading} numbered>
      <DataTable.Head>
        <th />
        <th />
        <th>SO #</th>
        <th>Date Created</th>
        <th>Customer</th>
        <th>Contact</th>
        <th>Email</th>
        <th>Buyer</th>
        <th>Co-Buyer</th>
        <th>Seller</th>
        <th>SN</th>
        <th>CD</th>
        <th className="text-center">Store Loc</th>
        <th className="text-center">Exch</th>
        <th className="text-left">QTY</th>
        <th className="text-right">Price Per Unit</th>
        <th className="text-right">Total</th>
      </DataTable.Head>
      <DataTable.Body>
        {results.map((r, i) => renderRow(r, i, pushHistory))}
      </DataTable.Body>
    </DataTable>
  );
}

Table.propTypes = {
  pushHistory: PropTypes.func.isRequired,
  ...SearchPropTypes
};

export default connect(undefined, { pushHistory: push })(Table);



// WEBPACK FOOTER //
// ./app/modules/parts/components/SalesOrderLineItems/Table.jsx